import styled from "styled-components";

import {
  WHITE,
  BACKGROUND_DIM,
  BORDER_PRIMARY,
  HOVER_LIGHT_BLUE,
} from "@/constants/colors";
import { FONT_SIZE_BASE, BODY, SEMI_BOLD, REGULAR } from "@/constants/fonts";

export const Table = styled.table`
  width: 100%;
`;

export const TableBody = styled.tbody`
  background-color: ${WHITE};
`;

export const TableHeaderRow = styled.tr`
  font-size: ${FONT_SIZE_BASE};
  background-color: ${BACKGROUND_DIM};
  font-family: ${BODY};
  font-weight: ${SEMI_BOLD};
  width: 100%;
  ${(props) => (props.autoHeight ? "" : "height: 50px;")}
  border-bottom: 1px solid ${BORDER_PRIMARY};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  th:first-child {
    padding: ${({ padding }) => (padding ? padding : "16px 24px")};
  }
  th:last-child {
    padding: ${({ padding }) => (padding ? padding : "16px 24px")};
    text-align: right;
  }
`;

export const TableFooterRow = styled.tr`
  font-size: ${FONT_SIZE_BASE};
  background-color: ${WHITE};
  font-family: ${BODY};
  font-weight: ${SEMI_BOLD};
  width: 100%;
  ${(props) => (props.autoHeight ? "" : "height: 66px;")}
  margin-left:  ${({ margin }) => (margin ? margin : "24px")};
  margin-right: ${({ margin }) => (margin ? margin : "24px")};
  td:first-child {
    padding-left: ${({ padding }) => (padding ? padding : "24px")};
  }
  td:last-child {
    padding-right: ${({ padding }) => (padding ? padding : "24px")};
    text-align: right;
  }
`;

export const TableRow = styled.tr`
  font-size: ${FONT_SIZE_BASE};
  background-color: ${({ background }) => background || WHITE};
  font-family: ${BODY};
  font-weight: ${REGULAR};
  width: 100%;
  ${(props) => (props.autoHeight ? "" : "height: 50px;")}
  border-bottom: 1px solid ${BORDER_PRIMARY};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 0;

  ${({ noHover }) =>
    noHover
      ? ""
      : `
    &:hover {
      cursor: pointer;
      background-color: ${HOVER_LIGHT_BLUE};
    }
  `}
`;
